export const contactTags = {
  tagsEmail: ["Primary", "Office", "Other"],
  tagsPhone: ["Primary", "Office", "Other"],
  tagsWeb: ["Primary"],
  tagsAddress: ["Primary", "Postal", "Office", "Other"],
};
